import styled from "styled-components";

export const ServicesBlocksWrapper = styled.section`

    width: 100%;
    height: 100%;
    .common-space{
        padding:50px 0;
    }
    .rowListingCol{
        padding-top: 100px;
    }
    @media (max-width: 991px) {
        .rowListingCol{
            padding-top: 50px;
        }
    }

`

export const ServicesColContainer = styled.div`
    background-color: var(--bg2);
    border-radius: 16px;
    overflow: hidden;
    height: 100%;
    .servicesBox{
        display: flex;
        width: 100%;
        height: 262px;
        span{
            width: 100%;
        }
        img{
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    
    .servicesColInnerContent{
        display: flex;
        flex-direction: column;
        padding: 30px;
    }
    .ctPointsList{
        display: block;
        width: 100%;
        padding: 0;
        ul{
            display: block;
            width: 100%;
            padding: 0;
            li{
                display: flex;
                width: 100%;
                padding: 0;
                gap: 12px;
                align-items: flex-start;
                margin-bottom: 12px;
                span{
                    width: 100%;
                }
                .listContent{
                    display: flex;
                    width: 100%;
                    flex-wrap: wrap;
                    padding-top: 1px;
                }
                .checkList{
                    min-width: 20px;
                    max-width: 20px;
                }
            }
        }
    }
    body.rtl &{
        .servicesColInnerContent{
            .main-heading{
                font-size: 24px;
                font-family: var(--arRegular);
            }
        }
    }
    @media (max-width: 767px) {
        .servicesColInnerContent{
            padding: 20px;
        }
    }
    @media (max-width: 575px) {
        .servicesColInnerContent{
            padding: 20px 15px 20px 15px;
            .main-heading{
                font-size: 24px;
            }
        }
    }
`







export const SuccessWrapper = styled.section`

    width: 100%;
    background-color: var(--darkColor) !important;
    background-size: cover !important;
    background-position: center center !important;
    background-repeat: no-repeat !important;
    .common-space{
        padding:50px 0;
    }
    .success-content{
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
    .success-btn{
        & button{
            background: #00B2FF;
            & div{
                background: var(--white);
                -webkit-text-fill-color: transparent;
                -webkit-background-clip: text;
            }
            svg{
                [fill]{
                    fill:var(--white);
                }
                [stroke]{
                    stroke:var(--white);
                }
            }
            &:hover{
                background: var(--white);
                box-shadow: 0px 3px 4px 0px rgb(108 107 107 / 25%);
                -webkit-box-shadow:0px 3px 4px 0px rgb(108 107 107 / 25%);
                -moz-box-shadow: 0px 3px 4px 0px rgb(108 107 107 / 25%);
        
                & >div{
                    font-family:var(--medium);
                    background: var(--gradient);
                    -webkit-text-fill-color: transparent;
                    -webkit-background-clip: text;
                }
                svg{
                    [fill]{
                        fill:var(--themeColor);
                    }
                    [stroke]{
                        stroke:var(--themeColor);
                    }
                }
            }
        }
    }

`

